<template>
  <div class="myPopoverMain" v-if="ybVisible_">
    <div class="myPopoverBg"></div>
    <div class="myPopover" :style="[styles]">
        <h4>译贝攻略</h4>
        <p>单个账户每天翻译1000字赠送10译贝哦，每天最多可以挣50译贝，超出10万字后按照5译贝/1000字消耗译贝</p>
        <button @click="onkonw">我知道了</button>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";

export default {
  name: "myPopover",
  props: {
    ybVisible: {
      type: [Boolean, String],
    },
    styles: {
      type: Object
    }
  },
  data() {
    return {

    };
  },
  computed: {
    ybVisible_(){
      return this.ybVisible
    }
  },
  methods: {
    onkonw() {
      this.$store.commit("setybPopover", false);
    }
  },
};
</script>

<style lang="less" scoped>
.myPopoverMain {
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 999;
}
.myPopoverBg {
  position: fixed;
  background: rgba(29, 29, 29, 1);
  opacity: 0.43;
  height: 100%;
  width: 100%;
  z-index: 999;
}
.myPopover {
  position: fixed;
  width: 355px;
  height: 217px;
  background: url("../assets/imgs/home/pop_image(img).png") no-repeat;
  border-radius: 10px;
  z-index: 1000;
  text-align: left;
  padding: 50px 20px 0px 20px;
  box-sizing: border-box;
  color: #797979;
  h4 {
    margin-top: 4px;
    height: 31px;
    font-size: 24px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: rgba(61, 105, 242, 1);
    line-height: 31px;
    margin-bottom: 5px;
    text-align: center;
  }
  p{
    font-size: 14px;
  }
  button {
    float: right;
    margin-top: 10px;
    width: 108px;
    height: 36px;
    background: rgba(61, 105, 242, 1);
    border-radius: 18px;
    font-size: 16px;
    color: rgba(255, 255, 255, 1);
  }
}
</style>